export const CRON_REPORT_TYPE = 'REPORT'
export const CRON_REPORT_SUBTYPE_JOB = 'JOB'
export const CRON_REPORT_SUBTYPE_VENDOR = 'VENDOR'
export const CRON_REPORT_SUBTYPE_CLIENT = 'CLIENT'
export const CRON_REPORT_SUBTYPE_QUOTE = 'QUOTE'
export const CRON_REPORT_SUBTYPE_PURCHASE_ORDER = 'PURCHASE ORDER'
export const CRON_REPORT_SUBTYPE_INVOICE = 'INVOICE'
export const CRON_REPORT_SUBTYPE_PAYMENT = 'PAYMENT'
export const CRON_REPORT_SUBTYPE_QA = 'QA'

export const CRON_REPORT_SUBTYPES = [
  CRON_REPORT_SUBTYPE_JOB,
  CRON_REPORT_SUBTYPE_VENDOR,
  CRON_REPORT_SUBTYPE_CLIENT,
  CRON_REPORT_SUBTYPE_QUOTE,
  CRON_REPORT_SUBTYPE_PURCHASE_ORDER,
  CRON_REPORT_SUBTYPE_INVOICE,
  CRON_REPORT_SUBTYPE_PAYMENT,
  CRON_REPORT_SUBTYPE_QA
]
